import React from 'react'
import { Fade } from 'react-reveal'

type AnimationType = 'slide-up' | 'fade-in'
type Props = { type: AnimationType; delay?: number; duration?: number; when?: boolean }

const Animate: React.FC<Props> = ({ type = 'fade-in', delay = 0, duration = 1000, children, when = true }) => {
  let settings = {}
  switch (type) {
    case 'slide-up':
      settings = {
        bottom: true,
        distance: '20px',
        delay,
        duration,
        when
      }
      break
    case 'fade-in':
      settings = {
        delay,
        duration,
        when
      }
      break
    default:
      settings = {
        bottom: true,
        distance: '20px',
        delay,
        duration,
        when
      }
      break
  }

  return (
    <div className='overflow-hidden'>
      <Fade {...settings}>{children}</Fade>
    </div>
  )
}

export default Animate
